// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AboutUs_wrapper__p8U_9","dark":"dark","title":"AboutUs_title__Lsh26","text":"AboutUs_text__7lkDm"};